import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { paraInputDateTime } from "../utils/reminderParser";
import {
  RECURRENCE_OPTIONS,
  REMINDER_RECURRENCE,
  getRecurrenceLabel,
} from "../utils/reminderStatus";

/** Sugestao inicial: proxima hora cheia, que e o que quase sempre se quer. */
function proximaHoraCheia() {
  const data = new Date();
  data.setHours(data.getHours() + 1, 0, 0, 0);
  return data;
}

/**
 * Escolha explicita de quando avisar, para quando os atalhos rapidos nao dao
 * conta. Usado pela pagina de captura e pela captura inline do dashboard.
 */
const PersonalizarLembreteModal = ({ show, onHide, onConfirm, onExited, valorInicial }) => {
  const [quando, setQuando] = useState("");
  const [recorrencia, setRecorrencia] = useState(REMINDER_RECURRENCE.NENHUMA);

  useEffect(() => {
    if (!show) return;

    setQuando(paraInputDateTime(valorInicial?.lembrarEm || proximaHoraCheia()));
    setRecorrencia(Number(valorInicial?.recorrencia) || REMINDER_RECURRENCE.NENHUMA);
  }, [show, valorInicial]);

  function confirmar() {
    if (!quando) return;

    onConfirm({
      lembrarEm: new Date(quando),
      recorrencia: Number(recorrencia) || REMINDER_RECURRENCE.NENHUMA,
    });
  }

  function limpar() {
    onConfirm({ lembrarEm: null, recorrencia: REMINDER_RECURRENCE.NENHUMA });
  }

  return (
    // onExited deixa quem chamou devolver o foco ao campo de captura sem
    // disputar com a restauracao de foco do proprio modal.
    <Modal show={show} onHide={onHide} onExited={onExited} centered>
      <Modal.Header closeButton>
        <Modal.Title>Quando avisar</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Data e hora</Form.Label>
          <Form.Control
            type="datetime-local"
            value={quando}
            autoFocus
            onChange={(evento) => setQuando(evento.target.value)}
          />
        </Form.Group>

        <Form.Group>
          <Form.Label>Repetir</Form.Label>
          <Form.Select
            value={recorrencia}
            disabled={!quando}
            onChange={(evento) => setRecorrencia(Number(evento.target.value))}
          >
            {RECURRENCE_OPTIONS.map((opcao) => (
              <option key={opcao} value={opcao}>
                {getRecurrenceLabel(opcao)}
              </option>
            ))}
          </Form.Select>
          <Form.Text muted>
            Ao concluir um lembrete que repete, ele pula para a proxima ocorrencia.
          </Form.Text>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        <Button variant="outline-secondary" onClick={limpar}>
          Sem alarme
        </Button>

        <div className="d-flex gap-2">
          <Button variant="secondary" onClick={onHide}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={confirmar} disabled={!quando}>
            Definir
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default PersonalizarLembreteModal;
